import React from 'react';
import type { SeparationOptions } from '@imagelayerdecomposer/core';

interface QualityPanelProps {
  options: SeparationOptions;
  onOptionsChange: (patch: Partial<SeparationOptions>) => void;
  warning: string | null;
}

export default function QualityPanel({
  options,
  onOptionsChange,
  warning,
}: QualityPanelProps) {
  return (
    <div className="panel">
      <div className="panel-header">
        <span>Quality</span>
      </div>
      <div className="control-row">
        <label>Noise reduction:</label>
        <input
          type="number"
          min="0"
          max="10"
          value={options.noiseReduction ?? 0}
          onChange={(e) =>
            onOptionsChange({ noiseReduction: parseInt(e.target.value, 10) })
          }
        />
      </div>
      <div className="control-row">
        <label>Speck removal (px):</label>
        <input
          type="number"
          min="0"
          max="100"
          value={options.speckRemoval ?? 0}
          onChange={(e) =>
            onOptionsChange({ speckRemoval: parseInt(e.target.value, 10) })
          }
        />
      </div>
      <div className="control-row inline">
        <label style={{ minWidth: 40 }}>Halftone:</label>
        <input
          type="checkbox"
          checked={options.halftoneEnabled ?? false}
          onChange={() =>
            onOptionsChange({ halftoneEnabled: !(options.halftoneEnabled ?? false) })
          }
        />
      </div>
      <div className="control-row inline">
        <label>Frequency:</label>
        <input
          type="number"
          min="2"
          max="64"
          value={options.halftoneFrequency ?? 16}
          onChange={(e) =>
            onOptionsChange({ halftoneFrequency: parseInt(e.target.value, 10) })
          }
        />
      </div>
      <div className="control-row inline">
        <label>Angle (deg):</label>
        <input
          type="number"
          min="0"
          max="180"
          value={options.halftoneAngle ?? 0}
          onChange={(e) =>
            onOptionsChange({ halftoneAngle: parseInt(e.target.value, 10) })
          }
        />
      </div>
      <div className="control-row inline">
        <label>Max colors:</label>
        <input
          type="number"
          min="1"
          max="30"
          value={options.maxPrintColors ?? 12}
          onChange={(e) =>
            onOptionsChange({ maxPrintColors: parseInt(e.target.value, 10) })
          }
        />
      </div>
      {warning && <div className="warning">{warning}</div>}
    </div>
  );
}
